import { H5_PLAY_EVENT } from '@tencent/super-player';

/**
 * 额外添加的一些播放器事件名、类型
 * web和win端的播放器事件不可能完全一致，以web端的事件类型优先
 * 如遇到win端没有的事件需要自行在这里定义一下
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export enum EVO_PLAY_EVENT {
  ON_ERROR = 'ON_ERROR',
  ON_PLAY_STATUS_CHANGE = 'ON_PLAY_STATUS_CHANGE',
  // TODO: 待也业务main-player改进，loop不监听事件实现(因为superplayer没有loop更新的事件)
  ON_LOOP_STATUS_CHANGE = 'ON_LOOP_STATUS_CHANGE',

  ON_FIRST_FRAME_RENDER = 'ON_FIRST_FRAME_RENDER', // 视频解码完成，第一帧渲染出来了
}


/** evo-player 和 superplayer 都有的播放流程事件 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export enum COMMON_PLAY_EVENT {
  // TODO: superplayer待实现
  // ON_ERROR = 'ON_ERROR',

  /** 视频正片开始播放
   *  @kind evo-player 对应 onPause
   *  @kind superplayer 对应 VIDEO_PLAYING
   */
  VIDEO_PLAYING = 'VIDEO_PLAYING',

  /** 视频正片暂停
   *  @kind evo-player 对应 onPause
   *  @kind superplayer 对应 VIDEO_PAUSE
   */
  VIDEO_PAUSE = 'VIDEO_PAUSE',

  /** 视频正片播放出错/结束
   *  @kind evo-player 对应 bindcomplete
   *  @kind superplayer 对应 PLAY_SESSION_END
   */
  VIDEO_COMPLETE = 'VIDEO_COMPLETE',

  /** 视频资源准备好了，可以播放
   *  @kind evo-player 对应 bindprepared
   *  @kind superplayer 对应 VIDEO_CANPLAY
   */
  VIDEO_CAN_PLAY = 'VIDEO_CAN_PLAY',

  /** 视频跳转结束
   *  @kind evo-player 对应 seek
   *  @kind superplayer 对应 VIDEO_SEEKING
   */
  SEEKING = 'SEEKING',

  /** 视频跳转结束
   *  @kind evo-player 对应 bindseekcompletion
   *  @kind superplayer 对应 VIDEO_SEEKED
   */
  SEEKED = 'SEEKED',

  /** 视频时长发生变化
   *  @kind evo-player 对应 bindsetposition
   *  @kind superplayer 对应 VIDEO_TIMEUPDATE
   */
  TIMEUPDATE = 'TIMEUPDATE',

  /** 音量发生变化
   *  @kind evo-player 对应 自行封装的方法 onVolumeUpdateAction, 音量被用户设置时触发
   *  @kind superplayer 对应 VIDEO_VOLUME_CHANGE
   */
  VOLUME_UPDATE = 'VOLUME_UPDATE',

  /** 视频清晰度切换开始
   *  @kind evo-player 对应 bindswitchdefinitionstart
   *  @kind superplayer 对应 VIDEO_SETLEVEL_START
   */
  CLARITY_UPDATE_START = 'CLARITY_UPDATE_START',

  /** 视频清晰度切换结束
   *  @kind evo-player 对应 bindswitchdefinitionend
   *  @kind superplayer 对应 VIDEO_SETLEVEL_END
   */
  CLARITY_UPDATE_END = 'CLARITY_UPDATE_END',

}


export const WebPlayerCommonEventMap: Partial<Record<COMMON_PLAY_EVENT, H5_PLAY_EVENT>> = import.meta.env.SSR ? {} : {
  [COMMON_PLAY_EVENT.VIDEO_PLAYING]: H5_PLAY_EVENT.VIDEO_PLAYING,
  [COMMON_PLAY_EVENT.VIDEO_PAUSE]: H5_PLAY_EVENT.VIDEO_PAUSE,
  [COMMON_PLAY_EVENT.VIDEO_COMPLETE]: H5_PLAY_EVENT.PLAY_SESSION_END,
  [COMMON_PLAY_EVENT.VIDEO_CAN_PLAY]: H5_PLAY_EVENT.VIDEO_CANPLAY,
  [COMMON_PLAY_EVENT.SEEKING]: H5_PLAY_EVENT.VIDEO_SEEKING,
  [COMMON_PLAY_EVENT.SEEKED]: H5_PLAY_EVENT.VIDEO_SEEKED,
  [COMMON_PLAY_EVENT.TIMEUPDATE]: H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
  [COMMON_PLAY_EVENT.VOLUME_UPDATE]: H5_PLAY_EVENT.VIDEO_VOLUME_CHANGE,
  [COMMON_PLAY_EVENT.CLARITY_UPDATE_START]: H5_PLAY_EVENT.VIDEO_SETLEVEL_START,
  [COMMON_PLAY_EVENT.CLARITY_UPDATE_END]: H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
  // TODO: superplayer待实现
  // [COMMON_PLAY_EVENT.ON_ERROR]: H5_PLAY_EVENT.PLAY_SESSION_END,
};
